export var HistoricDynamicStatsType;
(function (HistoricDynamicStatsType) {
    HistoricDynamicStatsType["CoveragesStats"] = "coverages-stats";
    HistoricDynamicStatsType["FlowCoveragesStats"] = "flow-coverages-stats";
    HistoricDynamicStatsType["CoveragesStatsByDebtorCountry"] = "coverages-stats-by-debtor-country";
    HistoricDynamicStatsType["CoveragesStatsByTradeSector"] = "coverages-stats-by-trade-sector";
    HistoricDynamicStatsType["CoveragesStatsByInsuranceCompany"] = "coverages-stats-by-insurance-company";
})(HistoricDynamicStatsType || (HistoricDynamicStatsType = {}));
